export const CampaignCategory = {
  DEAL: {
    name: "Deal",
    id: "10b6c2f4-fd85-41da-a6bc-ee78c98e7dc4"
  },
  PORTFOLIO: {
    name: "Portfolio",
    id: "10c6c2f4-fd85-41da-a6bc-ee78c98e7dc4"
  },
  OTHER: {
    name: "Other",
    id: "10d6c2f4-fd85-41da-a6bc-ee78c98e7dc4"
  }
};

export const CampaignType = {
  PREPAYMENT: {
    name: "Prepayment",
    id: "a7ef58c8-7619-466d-8860-fcc2c5ba4f4d",
    categoryId: CampaignCategory.DEAL.id
  },
  CASH_OUT_PROCEEDS: {
    name: "Cash Out Proceeds",
    id: "01870d97-5892-4b8f-aab1-94102b3213cb",
    categoryId: CampaignCategory.DEAL.id
  },
  REFI_BREAKEVEN: {
    name: "Refi Breakeven",
    id: "4d595e8a-552d-4ba4-ad7e-0440b8872968",
    categoryId: CampaignCategory.DEAL.id
  },
  VALUATION_SENSITIVITY: {
    name: "Valuation Sensitivity",
    id: "a8ef58c8-7619-466d-8860-fcc2c5ba4f4d",
    categoryId: CampaignCategory.DEAL.id
  },
  DEBT_WITH_US: {
    name: "Your Debt With Us",
    id: "a9ef58c8-7619-466d-8860-fcc2c5ba4f4d",
    categoryId: CampaignCategory.PORTFOLIO.id
  }
};

export const CampaignTypes = [
  {
    name: CampaignType.PREPAYMENT.name,
    id: CampaignType.PREPAYMENT.id,
    categoryId: CampaignType.PREPAYMENT.categoryId,
    label1: "Prepayment ($)",
    label2: "Prepayment (%)"
  },
  {
    name: CampaignType.CASH_OUT_PROCEEDS.name,
    id: CampaignType.CASH_OUT_PROCEEDS.id,
    categoryId: CampaignType.CASH_OUT_PROCEEDS.categoryId,
    label1: "Cash Out ($)",
    label2: "Cash Out (%)"
  },
  {
    name: CampaignType.REFI_BREAKEVEN.name,
    id: CampaignType.REFI_BREAKEVEN.id,
    categoryId: CampaignType.REFI_BREAKEVEN.categoryId,
    label1: "Breakeven Spread",
    label2: "Breakeven Treasury Rate"
  },
  {
    name: CampaignType.VALUATION_SENSITIVITY.name,
    id: CampaignType.VALUATION_SENSITIVITY.id,
    categoryId: CampaignType.VALUATION_SENSITIVITY.categoryId,
    label1: "Valuation (3% Cap Rate)",
    label2: "Valuation (6% Cap Rate)"
  },
  {
    name: CampaignType.DEBT_WITH_US.name,
    id: CampaignType.DEBT_WITH_US.id,
    categoryId: CampaignType.DEBT_WITH_US.categoryId,
    label1: "",
    label2: ""
  }
];

const convertToIntlFormat = num => new Intl.NumberFormat().format(Math.round(num * 10) / 10);

export const abbreviateNumber = (num, isRounded = false, isForLineChart = false) => {
  const convert = (n, char) => (isRounded && typeof n === "number" ? `${Math.round(convertToIntlFormat(n))} ${char}` : `${convertToIntlFormat(n)} ${char}`);
  if (num >= 1000000000) {
    return isForLineChart ? convert(num / 1000000000, "") : convert(num / 1000000000, "b");
  }
  if (num >= 1000000) {
    return isForLineChart ? convert(num / 1000000, "") : convert(num / 1000000, "mm");
  }
  if (num >= 1000) {
    return isForLineChart ? convert(num / 1000, "") : convert(num / 1000, "k");
  }

  return convertToIntlFormat(num);
};
